export class staticport{
  // static porturl = 'https://sbconsultancy.org.in/servlet/';
  // static porturl = 'https://sbdemowar.annaasilicontechnology.com/sbconsult/';
  // static porturl = 'https://sbdemowar.annaasilicontechnology.com/sbconsult/';
      // static porturl ='http://localhost:4200/';
      // static porturl ='http://localhost:8080/sbconsultancy/';
      static porturl = 'https://war.sbconsultancy.org.in/sbconsultancy/';

}